import React from 'react';
import {injectIntl} from 'react-intl';

const NoResults = ({intl, keyword, location}) => {
  return (
    <>
      <div className="block block--s">
        <div className="block__wrapper wrapper">
          <div className="block__header">
            <h2 className="block__title">{intl.formatMessage({id: 'NoResults.Title'})}</h2>
          </div>
          <div className="block__content block__content--xs body-copy color-preset--turquoise">
            <p> {intl.formatMessage({id: 'NoResults.Body'}, {
              // eslint-disable-next-line react/display-name
              span: (chunks) => (
                <span className="text--turquoise">{chunks}</span>
              ),
              keyword: keyword,
              location: location,
            })}
            </p>
            <ul className="list--checks">
              <li>{intl.formatMessage({id: 'NoResults.CheckOne'})}</li>
              <li>{intl.formatMessage({id: 'NoResults.CheckTwo'})}</li>
              <li>{intl.formatMessage({id: 'NoResults.CheckThree'})}</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(NoResults);
